import { VITE_BASE_URL } from '@/lib/constants';

/**
 * EnvironmentBanner displays the current environment (staging/development)
 * based on the VITE_BASE_URL with appropriate styling.
 * Does not display anything in production.
 */
export function EnvironmentBanner() {
    const isStaging = VITE_BASE_URL?.includes('-staging');
    const isDevelopment = !isStaging && VITE_BASE_URL?.includes('localhost');

    if (!isStaging && !isDevelopment) {
        return null;
    }

    const backgroundColor = isStaging ? '#da453f' : '#8b39e4';
    const label = isStaging ? 'Staging' : 'Development';

    return (
        <div
            className="px-2 py-1 text-sm font-medium text-white rounded"
            style={{ backgroundColor }}>
            {label}
        </div>
    );
}
